var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-wizard-dialog", {
    attrs: {
      title: _vm.$gettext("Seite hinzufügen"),
      confirmText: _vm.$gettext("Erstellen"),
      closeText: _vm.$gettext("Abbrechen"),
      slots: _vm.wizardSlots,
      lastRequiredSlotId: 1,
      requirements: _vm.requirements,
    },
    on: {
      close: _vm.closeAddDialog,
      confirm: _vm.createElement,
    },
    scopedSlots: _vm._u([
      {
        key: "basic",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "default",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c("label", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$gettext("Position der neuen Seite")) +
                      "\n                "
                  ),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pageParent,
                          expression: "pageParent",
                        },
                      ],
                      attrs: {
                        name: "relativePosition",
                      },
                      on: {
                        change: function change($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.pageParent = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      !_vm.isRoot && _vm.canEditParent
                        ? _c(
                            "option",
                            {
                              attrs: {
                                value: "sibling",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$gettext("Neben der aktuellen Seite")
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "option",
                        {
                          attrs: {
                            value: "descendant",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$gettext("Unterhalb der aktuellen Seite")
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("span", [_vm._v(_vm._s(_vm.text.title))]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "wizard-required",
                      attrs: {
                        "aria-hidden": "true",
                      },
                    },
                    [_vm._v("*")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.title,
                        expression: "title",
                      },
                    ],
                    attrs: {
                      type: "text",
                      name: "title",
                      required: "",
                    },
                    domProps: {
                      value: _vm.title,
                    },
                    on: {
                      input: function input($event) {
                        if ($event.target.composing) return
                        _vm.title = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("span", [_vm._v(_vm._s(_vm.$gettext("Beschreibung")))]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.description,
                        expression: "description",
                      },
                    ],
                    attrs: {
                      name: "description",
                      required: "",
                    },
                    domProps: {
                      value: _vm.description,
                    },
                    on: {
                      input: function input($event) {
                        if ($event.target.composing) return
                        _vm.description = $event.target.value
                      },
                    },
                  }),
                ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "template",
        fn: function fn() {
          return [
            _vm.hasTemplates
              ? _c(
                  "form",
                  {
                    staticClass: "default",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("label", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$gettext("Art der Vorlage")) +
                          "\n                "
                      ),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.templatePurpose,
                              expression: "templatePurpose",
                            },
                          ],
                          attrs: {
                            name: "templatePurpose",
                          },
                          on: {
                            change: function change($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.templatePurpose = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "content",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$gettext("Inhalt")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "oer",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$gettext("OER-Material")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "portfolio",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$gettext("ePortfolio")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "draft",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$gettext("Entwurf")))]
                          ),
                          _vm._v(" "),
                          !_vm.inCourseContext
                            ? _c(
                                "option",
                                {
                                  attrs: {
                                    value: "template",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$gettext("Aufgabenvorlage"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "other",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$gettext("Sonstiges")))]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("label", [
                      _c("span", [_vm._v(_vm._s(_vm.$gettext("Vorlage")))]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedTemplate,
                              expression: "selectedTemplate",
                            },
                          ],
                          attrs: {
                            name: "template",
                          },
                          on: {
                            change: function change($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.selectedTemplate = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            {
                              domProps: {
                                value: null,
                              },
                            },
                            [_vm._v(_vm._s(_vm.$gettext("ohne Vorlage")))]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.selectableTemplates, function (template) {
                            return _c(
                              "option",
                              {
                                key: template.id,
                                domProps: {
                                  value: template,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(template.attributes.name) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                  ]
                )
              : _c("courseware-companion-box", {
                  staticClass: "cw-companion-box-in-form",
                  attrs: {
                    msgCompanion: _vm.$gettext(
                      "Es wurden keine Vorlagen gefunden."
                    ),
                    mood: "pointing",
                  },
                }),
          ]
        },
        proxy: true,
      },
      {
        key: "layout",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "default",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "label",
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$gettext("Bild")) +
                        "\n                "
                    ),
                    _c("input", {
                      ref: "upload_image",
                      staticClass: "cw-file-input",
                      attrs: {
                        type: "file",
                        accept: "image/*",
                        name: "image",
                      },
                      on: {
                        change: _vm.checkUploadFile,
                      },
                    }),
                    _vm._v(" "),
                    _vm.uploadFileError
                      ? _c("courseware-companion-box", {
                          staticClass: "cw-companion-box-in-form",
                          attrs: {
                            msgCompanion: _vm.uploadFileError,
                            mood: "sad",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "label",
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$gettext("Farbe")) +
                        "\n                "
                    ),
                    _c("studip-select", {
                      attrs: {
                        options: _vm.colors,
                        reduce: function reduce(color) {
                          return color.class
                        },
                        label: "name",
                        name: "color",
                        clearable: false,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "open-indicator",
                          fn: function fn(selectAttributes) {
                            return [
                              _c(
                                "span",
                                _vm._b({}, "span", selectAttributes, false),
                                [
                                  _c("studip-icon", {
                                    attrs: {
                                      shape: "arr_1down",
                                      size: 10,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "no-options",
                          fn: function fn() {
                            return [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$gettext(
                                      "Es steht keine Auswahl zur Verfügung."
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "selected-option",
                          fn: function fn(option) {
                            return [
                              _c("span", {
                                staticClass: "vs__option-color",
                                style: {
                                  "background-color": option.hex,
                                },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(option.name))]),
                            ]
                          },
                        },
                        {
                          key: "option",
                          fn: function fn(option) {
                            return [
                              _c("span", {
                                staticClass: "vs__option-color",
                                style: {
                                  "background-color": option.hex,
                                },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(option.name))]),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.color,
                        callback: function callback($$v) {
                          _vm.color = $$v
                        },
                        expression: "color",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "advanced",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "default",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c("label", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$gettext("Art des Lernmaterials")) +
                      "\n                "
                  ),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.purpose,
                          expression: "purpose",
                        },
                      ],
                      attrs: {
                        name: "purpose",
                      },
                      on: {
                        change: function change($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.purpose = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        {
                          attrs: {
                            value: "content",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$gettext("Inhalt")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "option",
                        {
                          attrs: {
                            value: "oer",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$gettext("OER-Material")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "option",
                        {
                          attrs: {
                            value: "portfolio",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$gettext("ePortfolio")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "option",
                        {
                          attrs: {
                            value: "draft",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$gettext("Entwurf")))]
                      ),
                      _vm._v(" "),
                      !_vm.inCourseContext
                        ? _c(
                            "option",
                            {
                              attrs: {
                                value: "template",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$gettext("Aufgabenvorlage")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "option",
                        {
                          attrs: {
                            value: "other",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$gettext("Sonstiges")))]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.purposeIsOer
                  ? [
                      _c("label", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Lizenztyp")) +
                            "\n                    "
                        ),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.license_type,
                                expression: "license_type",
                              },
                            ],
                            on: {
                              change: function change($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.license_type = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.licenses, function (license) {
                            return _c(
                              "option",
                              {
                                key: license.id,
                                domProps: {
                                  value: license.id,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(license.name) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c("label", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$gettext("Geschätzter zeitlicher Aufwand")
                            ) +
                            "\n                    "
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.required_time,
                              expression: "required_time",
                            },
                          ],
                          attrs: {
                            type: "text",
                          },
                          domProps: {
                            value: _vm.required_time,
                          },
                          on: {
                            input: function input($event) {
                              if ($event.target.composing) return
                              _vm.required_time = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("label", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Niveau"))
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("von")) +
                            "\n                    "
                        ),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.difficulty_start,
                                expression: "difficulty_start",
                              },
                            ],
                            on: {
                              change: function change($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.difficulty_start = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: {
                                  value: "",
                                },
                              },
                              [_vm._v("-")]
                            ),
                            _vm._v(" "),
                            _vm._l(12, function (difficulty_start) {
                              return _c(
                                "option",
                                {
                                  key: difficulty_start,
                                  domProps: {
                                    value: difficulty_start,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(difficulty_start) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("bis")) +
                            "\n                    "
                        ),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.difficulty_end,
                                expression: "difficulty_end",
                              },
                            ],
                            on: {
                              change: function change($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.difficulty_end = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: {
                                  value: "",
                                },
                              },
                              [_vm._v("-")]
                            ),
                            _vm._v(" "),
                            _vm._l(12, function (difficulty_end) {
                              return _c(
                                "option",
                                {
                                  key: difficulty_end,
                                  domProps: {
                                    value: difficulty_end,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(difficulty_end) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }